import React from "react";
import {
  Box,
  Button,
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";

const FilterTemplate = ({ children }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      {children}
    </Box>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    gap: "20px",

    padding: "20px",
    background: "white",
    borderRadius: "15px",
    boxSizing: "border-box",
  }
}))

export default FilterTemplate
